import { Component } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("UI-Fehler abgefangen:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="p-8">
          <div className="max-w-md border border-red-500/40 bg-red-500/5 rounded-sm p-6 space-y-3">
            <div className="flex items-center gap-2 text-red-400">
              <AlertTriangle className="h-5 w-5" />
              <h2 className="font-heading text-sm font-bold uppercase tracking-wide">Etwas ist schiefgelaufen</h2>
            </div>
            <p className="text-sm text-zinc-400">
              Dieser Bereich konnte nicht angezeigt werden. Deine Eingaben wurden evtl. nicht gespeichert. Bitte lade die Seite neu oder wechsle den Bereich.
            </p>
            <button
              data-testid="error-boundary-reload"
              onClick={() => window.location.reload()}
              className="inline-flex items-center gap-2 rounded-sm bg-primary hover:bg-blue-600 text-white text-sm px-4 h-9 transition-colors"
            >
              <RotateCcw className="h-4 w-4" /> Neu laden
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
